export function splitStringByIndex(str, idx) {
  if (
    typeof str !== 'string' ||
    !str ||
    typeof idx !== 'number' ||
    Number.isNaN(idx)
  )
    return { before: '', after: '' };

  const before = str.substring(0, idx);

  const after = str.substring(idx);

  return { before, after };
}
